import React from 'react';
import ReactQuill from 'react-quill';
import { getAssignmentFieldLabel } from '../slack/assignmentFieldOptions';

const Embed = ReactQuill.Quill.import('blots/embed');

/**
 * Factory function to create AssignmentFieldBlot with quillRef access for deletion
 */
export const createAssignmentFieldBlot = (quillRef: React.MutableRefObject<ReactQuill>) => {
  class AssignmentFieldBlot extends Embed {
    static create(data: { fieldValue: string; fieldLabel: string } | string) {
      const node = super.create();

      // Handle both object (from insertEmbed) and string (from HTML parsing)
      const fieldValue = typeof data === 'string' ? data : data.fieldValue;
      const fieldLabel = typeof data === 'string' ? getAssignmentFieldLabel(data) : data.fieldLabel;

      node.setAttribute('data-field-value', fieldValue);
      node.setAttribute('data-field-label', fieldLabel);

      const innerDiv = document.createElement('span');
      innerDiv.setAttribute('contenteditable', 'false');
      innerDiv.classList.add('disablePointerEvents');

      const taglineCss = `
        text-transform: capitalize;
        border-radius: 4px;
        background: #E8F5E9;
        padding: 0 4px;
        font-size: 12px;
        color: #4B4B4B;
        display: inline-block;
      `;
      innerDiv.setAttribute('style', taglineCss);
      innerDiv.innerText = fieldLabel;

      // Add delete button
      const exitNode = document.createElement('span');
      exitNode.setAttribute('contenteditable', 'false');
      exitNode.classList.add('tagDeleteClass');
      const deleteTagCss = `
        font-size: 10px;
        display: inline-block;
        padding: 0 6px;
        cursor: pointer;
        position: relative;
      `;
      exitNode.setAttribute('style', deleteTagCss);
      exitNode.innerText = 'X';

      exitNode.addEventListener('click', function () {
        if (quillRef.current) {
          const quillEditor = quillRef.current.getEditor();
          const range = quillEditor.getSelection(true);
          quillEditor.deleteText(range.index - 1, 1, 'user');
        }
      });

      innerDiv.append(exitNode);
      node.appendChild(innerDiv);
      return node;
    }

    static formats(node: HTMLElement) {
      return {
        fieldValue: node.getAttribute('data-field-value'),
        fieldLabel: node.getAttribute('data-field-label'),
      };
    }

    static value(node: HTMLElement) {
      return {
        fieldValue: node.getAttribute('data-field-value'),
        fieldLabel: node.getAttribute('data-field-label'),
      };
    }
  }

  AssignmentFieldBlot.blotName = 'assignmentField';
  AssignmentFieldBlot.tagName = 'span';
  AssignmentFieldBlot.className = 'assignmentField';

  return AssignmentFieldBlot;
};
